import React from 'react';
import CryptoJS from 'crypto-js';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { SubmissionError } from 'redux-form';
import { withNamespaces } from 'react-i18next';
import { withResource, resourceTypes } from 'dataModule/store/resources';
import { actionCreators as messageActionCreators } from 'appModule/message/ducks/message';
import { Loading } from 'utilsModule/components';
import SetNewPassword from '../components/SetNewPassword';

@withNamespaces('auth', { wait: true })
@withResource([{ resourceType: resourceTypes.USERS }])
@connect(null, { notify: messageActionCreators.show })
@withRouter
class SetNewPasswordContainer extends React.Component {
  static propTypes = {
    actionCreators: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  shouldComponentUpdate(nextProps) {
    return !nextProps.data.status.loading;
  }

  handleCreate = ({ encryptPassword }) => {
    const {
      t,
      actionCreators,
      notify,
      location: {
        state: {
          changePassword = false,
        } = {},
      } = {},
    } = this.props;

    const verifyPhone = sessionStorage.getItem('verifyPhone');

    // Encrypt the password before sending to the BE
    const cipherText = CryptoJS.AES.encrypt(encryptPassword, '@2ecret4uth2907!');
    const password = cipherText.toString();

    return new Promise((resolve, reject) =>
      actionCreators[resourceTypes.USERS].ajax({
        cargo: { method: 'resetPassword', input: { content: { phone: verifyPhone, password, isChangePassword: changePassword } } },
        onSuccess: ({ data: registerAuthData }) => {
          if (this.mounted) {
            sessionStorage.clear();
            resolve(registerAuthData);

            notify({ message: t('forgetPassword.snackbarMessage.passwordUpdateSuccess'), type: 'success' });
            setTimeout(() => {
              window.location.href = 'https://www.healthbeats.co';
            }, 3000);
          }
        },
        onFailure: (error) => {
          if (this.mounted) {
            const { error: { message, code } } = error;

            if (code == '2000105') {
              reject(new SubmissionError({
                encryptPassword: message,
                confirmPassword: message,
                _error: message,
              }));
              notify({ message: t('forgetPassword.snackbarMessage.passwordUsedBefore'), type: 'error' });
            } else if (code == '2000106') {
              reject(new SubmissionError({
                encryptPassword: message,
                confirmPassword: message,
                _error: message,
              }));
              notify({
                message: t('forgetPassword.snackbarMessage.passwordSameAsCurrent'),
                type: 'error',
              });
            } else {
              reject(new SubmissionError({
                _error: message,
              }));
              notify({
                message: (!_.isEmpty(message)) ? message : t('forgetPassword.snackbarMessage.passwordUpdateFailed'),
                type: 'error'
              });
            }
          }
        },
      }));
  }

  render() {
    const { t, data, location: { state: { changePassword = false } = {} } = {} } = this.props;

    // First render
    if (data.status.loading) return <Loading />;

    this.runtimeProps = {
      header: {
        banner: {
          title: t('forgetPassword.title3'),
          subtitle1: t('forgetPassword.subtitle3-1'),
          subtitle2: t('forgetPassword.subtitle3-2'),
        },
      },
    };

    return (
      <SetNewPassword
        t={t}
        initialValues={this.initialValues}
        runtimeProps={this.runtimeProps}
        handleCreate={this.handleCreate}
        handleResend={this.handleResend}
        changePassword={changePassword}
      />
    );
  }
}

export default SetNewPasswordContainer;
